<template>
  <body class="text-center centrarBody">
    <div>
      <v-row>
        <v-col cols="12">
          <h1>Bienvenido a la plataforma de acceso a Clientes</h1>
        </v-col>
        <v-col cols="12">
          <h5>Ingresa tus datos de acceso</h5>
        </v-col>
      </v-row>
      <div class="centrarBody">
        <v-form ref="form" v-model="formularioValido">
          <v-row>
            <v-col cols="12" md="12" lg="6" xl="6">
              <v-row align="center" justify="start" class="reduce-down">
                <v-col cols="12" md="3" lg="3">
                  <p class="text-start title font-weight-bold mb-0" style="font-size:1.02rem !important;line-height: 1.2rem;">RFC<b style="color: #5DC00A"> *</b></p>
                </v-col>
                <v-col cols="12" md="9" lg="9">
                  <v-text-field
                    v-model="credenciales.rfc"
                    :rules="[nameRules.rfcVacio, nameRules.rfcValido]"
                    outlined dense
                    color="green darken-3"
                    hide-details="auto"
                    autocomplete="new-password"
                    class="big-input"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="12" lg="6" xl="6">
              <v-row align="center" justify="start" class="reduce-down">
                <v-col cols="12" md="3" lg="3">
                  <p class="text-start title font-weight-bold mb-0" style="font-size:1.02rem !important;line-height: 1.2rem;">Contraseña<b style="color: #5DC00A"> *</b></p>
                </v-col>
                <v-col cols="12" md="9" lg="9">
                  <v-text-field
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[nameRules.contrasenaVacia]"
                    :type="show1 ? 'text' : 'password'"
                    name="input-10-1"
                    color="green darken-3"
                    @click:append="show1 = !show1"
                    v-model="credenciales.contrasena"
                    outlined dense hide-details="auto"
                    @keypress.enter="btnIniciarSesion"
                    autocomplete="new-password"
                    class="big-input"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <my-captcha
                :callSuccess="captchaOk2"
                color="green"
                mode="math"
                resolve="text"
                style="margin: auto"
                :key="rerender"
              ></my-captcha>
            </v-col>
            <v-col cols="12" v-if="captchaerror">
              <v-alert type="error">
                Debes completar la operación para continuar
              </v-alert>
            </v-col>
            <v-col cols="12" v-if="errorInicio">
              <label class="red--text">{{ mensajeInicio }}</label>
            </v-col>
            <v-col cols="12">
              <v-btn
                :disabled="!formularioValido"
                color="#008230"
                class="white--text btn-new"
                block
                x-large
                @click="btnIniciarSesion"
                >Iniciar sesión</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
        <v-row>
          <v-col cols="12">
            <span>¿Aún no tienes cuenta de acceso? </span
            ><router-link to="/registro"
              >Regístrate ahora</router-link
            >
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <span>¿Olvidaste tu contraseña? </span
            ><router-link to="/solicitarrecuperacion"
              >Recuperar contraseña</router-link
            >
          </v-col>
        </v-row>
      </div>
    </div>
    <div>
      <LoaderDialog></LoaderDialog>
    </div>
  </body>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LoaderDialog from "@/components/LoaderDialog.vue";
import router from '@/router/index.js';
import myCaptcha from 'vue-captcha';

export default {
  name: "IniciarSesion",
  components: {
    LoaderDialog,
    'my-captcha': myCaptcha,
  },
  computed: {
    ...mapState(["errorInicio", "mensajeInicio"])
  },
  mounted: function() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });	
  },
  data() {
    return {
      show1: false,
      rerender:  0,
      credenciales: {
        rfc: "",
        contrasena: ""
      },
      formularioValido: false,
      nameRules: {
        rfcVacio: v => !!v || "RFC requerido",
        rfcValido: v =>
          /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([A-Z\d]{3})?$/.test(
            v
          ) || "Ingrese un RFC valido",
        contrasenaVacia: v => !!v || "Contraseña requerida"
      },
      captcha: false,
      captchaerror: false,
    };
  },
  methods: {
    ...mapActions(["iniciarSesion"]),
    btnIniciarSesion(){
      if(this.captcha){
        this.$store.dispatch("iniciarSesion", this.credenciales)
        .then(()=>{
          this.forceRerender();
        });
      }else{
        this.captchaerror = true;
      }
    },
    forceRerender(){
      this.rerender += 1;
      this.captcha = false;
    },
    captchaOk2 () {
	    this.captcha = true;
	    this.captchaerror = false;
	  },
  },
  beforeCreate(){

    let searchParams = new URLSearchParams(window.location.search)
    let param = searchParams.get('token')
    if(param != null){
      console.log(param);
      localStorage.setItem('token', param);
      router.push({name: 'reestablecercontrasena'});
    }

    var cuenta = JSON.parse(sessionStorage.getItem("cuenta"));
    if(cuenta!=null){
      this.$store.commit("guardarCuenta", cuenta);
      router.push({name: 'Home'});
    }
  }
};
</script>

<style scoped>
.imagen {
  width: 150px;
  height: auto;
  display: inline-block;
}
.centrarBody {
  padding-left: 10%;
  padding-right: 10%;
  margin-bottom: 50px;
}

@media screen and (max-width: 585px) {
  .centrarBody {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>
